import styled from 'styled-components';
import { Box, Chip as MUIChip } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const Chip = styled(MUIChip)`
  &.MuiChip-filled {
    color: ${({ theme }) => theme.palette.common.white};
    font-size: 13px;
    line-height: 18px;
    font-weight: 400;
    text-transform: capitalize;
    &:nth-child(3n + 1) {
      background-color: ${({ theme }) => theme.palette.warning.main};
    }
    &:nth-child(3n + 2) {
      background-color: ${({ theme }) => theme.palette.secondary.main};
    }
    &:nth-child(3n + 3) {
      background-color: ${({ theme }) => theme.palette.primary.dark};
    }
  }

  svg {
    fill: ${({ theme }) => theme.palette.common.white};
    opacity: 0.7;
  }
`;
